// Generated by purs version 0.13.8
"use strict";
var Control_Alt = require("../Control.Alt/index.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Category = require("../Control.Category/index.js");
var Control_Lazy = require("../Control.Lazy/index.js");
var Control_Monad_Reader_Class = require("../Control.Monad.Reader.Class/index.js");
var Control_Monad_Reader_Trans = require("../Control.Monad.Reader.Trans/index.js");
var Control_Monad_State = require("../Control.Monad.State/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Control_Monad_State_Trans = require("../Control.Monad.State.Trans/index.js");
var Control_Monad_Trans_Class = require("../Control.Monad.Trans.Class/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Date = require("../Data.Date/index.js");
var Data_Date_Component = require("../Data.Date.Component/index.js");
var Data_DateTime = require("../Data.DateTime/index.js");
var Data_DateTime_Instant = require("../Data.DateTime.Instant/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Enum = require("../Data.Enum/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_EuclideanRing = require("../Data.EuclideanRing/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Formatter_Internal = require("../Data.Formatter.Internal/index.js");
var Data_Formatter_Parser_Number = require("../Data.Formatter.Parser.Number/index.js");
var Data_Formatter_Parser_Utils = require("../Data.Formatter.Parser.Utils/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Generic_Rep_Show = require("../Data.Generic.Rep.Show/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_List = require("../Data.List/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ordering = require("../Data.Ordering/index.js");
var Data_Ring = require("../Data.Ring/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_CodePoints = require("../Data.String.CodePoints/index.js");
var Data_String_CodeUnits = require("../Data.String.CodeUnits/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Time = require("../Data.Time/index.js");
var Data_Time_Component = require("../Data.Time.Component/index.js");
var Data_Time_Duration = require("../Data.Time.Duration/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Text_Parsing_Parser = require("../Text.Parsing.Parser/index.js");
var Text_Parsing_Parser_Combinators = require("../Text.Parsing.Parser.Combinators/index.js");
var Text_Parsing_Parser_String = require("../Text.Parsing.Parser.String/index.js");
var AM = (function () {
    function AM() {

    };
    AM.value = new AM();
    return AM;
})();
var PM = (function () {
    function PM() {

    };
    PM.value = new PM();
    return PM;
})();
var YearFull = (function () {
    function YearFull() {

    };
    YearFull.value = new YearFull();
    return YearFull;
})();
var YearTwoDigits = (function () {
    function YearTwoDigits() {

    };
    YearTwoDigits.value = new YearTwoDigits();
    return YearTwoDigits;
})();
var YearAbsolute = (function () {
    function YearAbsolute() {

    };
    YearAbsolute.value = new YearAbsolute();
    return YearAbsolute;
})();
var MonthFull = (function () {
    function MonthFull() {

    };
    MonthFull.value = new MonthFull();
    return MonthFull;
})();
var MonthShort = (function () {
    function MonthShort() {

    };
    MonthShort.value = new MonthShort();
    return MonthShort;
})();
var MonthTwoDigits = (function () {
    function MonthTwoDigits() {

    };
    MonthTwoDigits.value = new MonthTwoDigits();
    return MonthTwoDigits;
})();
var DayOfMonthTwoDigits = (function () {
    function DayOfMonthTwoDigits() {

    };
    DayOfMonthTwoDigits.value = new DayOfMonthTwoDigits();
    return DayOfMonthTwoDigits;
})();
var DayOfMonth = (function () {
    function DayOfMonth() {

    };
    DayOfMonth.value = new DayOfMonth();
    return DayOfMonth;
})();
var UnixTimestamp = (function () {
    function UnixTimestamp() {

    };
    UnixTimestamp.value = new UnixTimestamp();
    return UnixTimestamp;
})();
var DayOfWeek = (function () {
    function DayOfWeek() {

    };
    DayOfWeek.value = new DayOfWeek();
    return DayOfWeek;
})();
var DayOfWeekName = (function () {
    function DayOfWeekName() {

    };
    DayOfWeekName.value = new DayOfWeekName();
    return DayOfWeekName;
})();
var DayOfWeekNameShort = (function () {
    function DayOfWeekNameShort() {

    };
    DayOfWeekNameShort.value = new DayOfWeekNameShort();
    return DayOfWeekNameShort;
})();
var Hours24 = (function () {
    function Hours24() {

    };
    Hours24.value = new Hours24();
    return Hours24;
})();
var Hours12 = (function () {
    function Hours12() {

    };
    Hours12.value = new Hours12();
    return Hours12;
})();
var Meridiem = (function () {
    function Meridiem() {

    };
    Meridiem.value = new Meridiem();
    return Meridiem;
})();
var Minutes = (function () {
    function Minutes() {

    };
    Minutes.value = new Minutes();
    return Minutes;
})();
var MinutesTwoDigits = (function () {
    function MinutesTwoDigits() {

    };
    MinutesTwoDigits.value = new MinutesTwoDigits();
    return MinutesTwoDigits;
})();
var Seconds = (function () {
    function Seconds() {

    };
    Seconds.value = new Seconds();
    return Seconds;
})();
var SecondsTwoDigits = (function () {
    function SecondsTwoDigits() {

    };
    SecondsTwoDigits.value = new SecondsTwoDigits();
    return SecondsTwoDigits;
})();
var Milliseconds = (function () {
    function Milliseconds() {

    };
    Milliseconds.value = new Milliseconds();
    return Milliseconds;
})();
var MillisecondsShort = (function () {
    function MillisecondsShort() {

    };
    MillisecondsShort.value = new MillisecondsShort();
    return MillisecondsShort;
})();
var MillisecondsTwoDigits = (function () {
    function MillisecondsTwoDigits() {

    };
    MillisecondsTwoDigits.value = new MillisecondsTwoDigits();
    return MillisecondsTwoDigits;
})();
var Placeholder = (function () {
    function Placeholder(value0) {
        this.value0 = value0;
    };
    Placeholder.create = function (value0) {
        return new Placeholder(value0);
    };
    return Placeholder;
})();
var validateRange = function (min) {
    return function (max) {
        return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Either.bindEither))(Control_Monad_Reader_Class.ask(Control_Monad_Reader_Trans.monadAskReaderT(Data_Either.monadEither)))(function (v) {
            return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(Data_Either.monadEither)((function () {
                var $92 = v.num < min || v.num > max;
                if ($92) {
                    return Data_Either.Left.create("Number is out of range [ " + (Data_Show.show(Data_Show.showInt)(min) + (", " + (Data_Show.show(Data_Show.showInt)(max) + " ]"))));
                };
                return new Data_Either.Right(Data_Unit.unit);
            })());
        });
    };
};
var validAccum = function (v) {
    if (v.hour instanceof Data_Maybe.Just && v.hour.value0 === 24) {
        return Data_Foldable.for_(Data_Either.applicativeEither)(Data_Foldable.foldableArray)([ v.minute, v.second, v.millisecond ])(function (val) {
            return Control_Applicative.when(Data_Either.applicativeEither)(Data_Maybe.fromMaybe(0)(val) > 0)(new Data_Either.Left("When hour is 24, other time components must be 0"));
        });
    };
    return Control_Applicative.pure(Data_Either.applicativeEither)(Data_Unit.unit);
};
var takeSome = function (dictAlternative) {
    return function (dictLazy) {
        return function (v) {
            return function (v1) {
                if (v === 0) {
                    return Control_Applicative.pure(dictAlternative.Applicative0())(Data_List_Types.Nil.value);
                };
                return Control_Apply.apply((dictAlternative.Applicative0()).Apply0())(Data_Functor.map(((dictAlternative.Plus1()).Alt0()).Functor0())(Data_List_Types.Cons.create)(v1))(Control_Lazy.defer(dictLazy)(function (v3) {
                    return takeMany(dictAlternative)(dictLazy)(v - 1 | 0)(v1);
                }));
            };
        };
    };
};
var takeMany = function (dictAlternative) {
    return function (dictLazy) {
        return function (v) {
            return function (v1) {
                if (v === 0) {
                    return Control_Applicative.pure(dictAlternative.Applicative0())(Data_List_Types.Nil.value);
                };
                return Control_Alt.alt((dictAlternative.Plus1()).Alt0())(takeSome(dictAlternative)(dictLazy)(v)(v1))(Control_Applicative.pure(dictAlternative.Applicative0())(Data_List_Types.Nil.value));
            };
        };
    };
};
var printShortMonth = function (v) {
    if (v instanceof Data_Date_Component.January) {
        return "Jan";
    };
    if (v instanceof Data_Date_Component.February) {
        return "Feb";
    };
    if (v instanceof Data_Date_Component.March) {
        return "Mar";
    };
    if (v instanceof Data_Date_Component.April) {
        return "Apr";
    };
    if (v instanceof Data_Date_Component.May) {
        return "May";
    };
    if (v instanceof Data_Date_Component.June) {
        return "Jun";
    };
    if (v instanceof Data_Date_Component.July) {
        return "Jul";
    };
    if (v instanceof Data_Date_Component.August) {
        return "Aug";
    };
    if (v instanceof Data_Date_Component.September) {
        return "Sep";
    };
    if (v instanceof Data_Date_Component.October) {
        return "Oct";
    };
    if (v instanceof Data_Date_Component.November) {
        return "Nov";
    };
    if (v instanceof Data_Date_Component.December) {
        return "Dec";
    };
    throw new Error("Failed pattern match at Data.Formatter.DateTime (line 482, column 19 - line 494, column 21): " + [ v.constructor.name ]);
};
var printFormatterCommand = function (v) {
    if (v instanceof YearFull) {
        return "YYYY";
    };
    if (v instanceof YearTwoDigits) {
        return "YY";
    };
    if (v instanceof YearAbsolute) {
        return "Y";
    };
    if (v instanceof MonthFull) {
        return "MMMM";
    };
    if (v instanceof MonthShort) {
        return "MMM";
    };
    if (v instanceof MonthTwoDigits) {
        return "MM";
    };
    if (v instanceof DayOfMonthTwoDigits) {
        return "DD";
    };
    if (v instanceof DayOfMonth) {
        return "D";
    };
    if (v instanceof UnixTimestamp) {
        return "X";
    };
    if (v instanceof DayOfWeek) {
        return "E";
    };
    if (v instanceof DayOfWeekName) {
        return "dddd";
    };
    if (v instanceof DayOfWeekNameShort) {
        return "ddd";
    };
    if (v instanceof Hours24) {
        return "HH";
    };
    if (v instanceof Hours12) {
        return "hh";
    };
    if (v instanceof Meridiem) {
        return "a";
    };
    if (v instanceof Minutes) {
        return "m";
    };
    if (v instanceof MinutesTwoDigits) {
        return "mm";
    };
    if (v instanceof Seconds) {
        return "s";
    };
    if (v instanceof SecondsTwoDigits) {
        return "ss";
    };
    if (v instanceof MillisecondsShort) {
        return "S";
    };
    if (v instanceof MillisecondsTwoDigits) {
        return "SS";
    };
    if (v instanceof Milliseconds) {
        return "SSS";
    };
    if (v instanceof Placeholder) {
        return v.value0;
    };
    throw new Error("Failed pattern match at Data.Formatter.DateTime (line 84, column 25 - line 107, column 20): " + [ v.constructor.name ]);
};
var printFormatter = Data_Foldable.foldMap(Data_List_Types.foldableList)(Data_Monoid.monoidString)(printFormatterCommand);
var placeholderContent = Data_Functor.mapFlipped(Text_Parsing_Parser.functorParserT(Data_Identity.functorIdentity))(Data_Array.some(Text_Parsing_Parser.alternativeParserT(Data_Identity.monadIdentity))(Text_Parsing_Parser.lazyParserT)(Text_Parsing_Parser_String.noneOf(Text_Parsing_Parser_String.stringLikeString)(Data_Identity.monadIdentity)(Data_String_CodeUnits.toCharArray("YMDEHhamsS"))))(Data_String_CodeUnits.fromCharArray);
var parseShortMonth = function (dictMonad) {
    return Data_Formatter_Parser_Utils.oneOfAs(Data_Functor.functorArray)(Data_Foldable.foldableArray)(dictMonad)((function () {
        var $435 = Text_Parsing_Parser_Combinators["try"](dictMonad);
        var $436 = Text_Parsing_Parser_String.string(Text_Parsing_Parser_String.stringLikeString)(dictMonad);
        return function ($437) {
            return $435($436($437));
        };
    })())([ new Data_Tuple.Tuple("Jan", Data_Date_Component.January.value), new Data_Tuple.Tuple("Feb", Data_Date_Component.February.value), new Data_Tuple.Tuple("Mar", Data_Date_Component.March.value), new Data_Tuple.Tuple("Apr", Data_Date_Component.April.value), new Data_Tuple.Tuple("May", Data_Date_Component.May.value), new Data_Tuple.Tuple("Jun", Data_Date_Component.June.value), new Data_Tuple.Tuple("Jul", Data_Date_Component.July.value), new Data_Tuple.Tuple("Aug", Data_Date_Component.August.value), new Data_Tuple.Tuple("Sep", Data_Date_Component.September.value), new Data_Tuple.Tuple("Oct", Data_Date_Component.October.value), new Data_Tuple.Tuple("Nov", Data_Date_Component.November.value), new Data_Tuple.Tuple("Dec", Data_Date_Component.December.value) ]);
};
var parseMonth = function (dictMonad) {
    return Data_Formatter_Parser_Utils.oneOfAs(Data_Functor.functorArray)(Data_Foldable.foldableArray)(dictMonad)((function () {
        var $438 = Text_Parsing_Parser_Combinators["try"](dictMonad);
        var $439 = Text_Parsing_Parser_String.string(Text_Parsing_Parser_String.stringLikeString)(dictMonad);
        return function ($440) {
            return $438($439($440));
        };
    })())([ new Data_Tuple.Tuple("January", Data_Date_Component.January.value), new Data_Tuple.Tuple("February", Data_Date_Component.February.value), new Data_Tuple.Tuple("March", Data_Date_Component.March.value), new Data_Tuple.Tuple("April", Data_Date_Component.April.value), new Data_Tuple.Tuple("May", Data_Date_Component.May.value), new Data_Tuple.Tuple("June", Data_Date_Component.June.value), new Data_Tuple.Tuple("July", Data_Date_Component.July.value), new Data_Tuple.Tuple("August", Data_Date_Component.August.value), new Data_Tuple.Tuple("September", Data_Date_Component.September.value), new Data_Tuple.Tuple("October", Data_Date_Component.October.value), new Data_Tuple.Tuple("November", Data_Date_Component.November.value), new Data_Tuple.Tuple("December", Data_Date_Component.December.value) ]);
};
var parseMeridiem = function (dictMonad) {
    return Data_Formatter_Parser_Utils.oneOfAs(Data_Functor.functorArray)(Data_Foldable.foldableArray)(dictMonad)((function () {
        var $441 = Text_Parsing_Parser_Combinators["try"](dictMonad);
        var $442 = Text_Parsing_Parser_String.string(Text_Parsing_Parser_String.stringLikeString)(dictMonad);
        return function ($443) {
            return $441($442($443));
        };
    })())([ new Data_Tuple.Tuple("am", AM.value), new Data_Tuple.Tuple("AM", AM.value), new Data_Tuple.Tuple("pm", PM.value), new Data_Tuple.Tuple("PM", PM.value) ]);
};
var $$parseInt = function (dictMonad) {
    return function (maxLength) {
        return function (validators) {
            return function (errMsg) {
                return Control_Bind.bind(Text_Parsing_Parser.bindParserT(dictMonad))(takeSome(Text_Parsing_Parser.alternativeParserT(dictMonad))(Text_Parsing_Parser.lazyParserT)(maxLength)(Data_Formatter_Parser_Number.parseDigit(dictMonad)(Text_Parsing_Parser_String.stringLikeString)))(function (ds) {
                    var num = Data_Formatter_Internal.foldDigits(Data_List_Types.foldableList)(ds);
                    var length = Data_List.length(ds);
                    var v = Control_Monad_Reader_Trans.runReaderT(validators)({
                        length: length,
                        num: num,
                        maxLength: maxLength
                    });
                    if (v instanceof Data_Either.Left) {
                        return Text_Parsing_Parser.fail(dictMonad)(errMsg + ("(" + (v.value0 + ")")));
                    };
                    if (v instanceof Data_Either.Right) {
                        return Control_Applicative.pure(Text_Parsing_Parser.applicativeParserT(dictMonad))(num);
                    };
                    throw new Error("Failed pattern match at Data.Formatter.DateTime (line 336, column 3 - line 338, column 23): " + [ v.constructor.name ]);
                });
            };
        };
    };
};
var parseSignedInt = function (dictMonad) {
    return function (maxLength) {
        return function (validators) {
            return function (errMsg) {
                return Control_Bind.bind(Text_Parsing_Parser.bindParserT(dictMonad))(Data_Functor.map(Text_Parsing_Parser.functorParserT(((dictMonad.Bind1()).Apply0()).Functor0()))(Data_Maybe.isJust)(Text_Parsing_Parser_Combinators.optionMaybe(dictMonad)(Text_Parsing_Parser_String["char"](Text_Parsing_Parser_String.stringLikeString)(dictMonad)("-"))))(function (isNegative) {
                    return Data_Functor.map(Text_Parsing_Parser.functorParserT(((dictMonad.Bind1()).Apply0()).Functor0()))((function () {
                        if (isNegative) {
                            return Data_Ring.negate(Data_Ring.ringInt);
                        };
                        return Control_Category.identity(Control_Category.categoryFn);
                    })())($$parseInt(dictMonad)(maxLength)(validators)(errMsg));
                });
            };
        };
    };
};
var parseDayOfWeekNameShort = function (dictMonad) {
    return Data_Formatter_Parser_Utils.oneOfAs(Data_Functor.functorArray)(Data_Foldable.foldableArray)(dictMonad)((function () {
        var $444 = Text_Parsing_Parser_Combinators["try"](dictMonad);
        var $445 = Text_Parsing_Parser_String.string(Text_Parsing_Parser_String.stringLikeString)(dictMonad);
        return function ($446) {
            return $444($445($446));
        };
    })())([ new Data_Tuple.Tuple("Mon", Data_Date_Component.Monday.value), new Data_Tuple.Tuple("Tue", Data_Date_Component.Tuesday.value), new Data_Tuple.Tuple("Wed", Data_Date_Component.Wednesday.value), new Data_Tuple.Tuple("Thu", Data_Date_Component.Thursday.value), new Data_Tuple.Tuple("Fri", Data_Date_Component.Friday.value), new Data_Tuple.Tuple("Sat", Data_Date_Component.Saturday.value), new Data_Tuple.Tuple("Sun", Data_Date_Component.Sunday.value) ]);
};
var parseDayOfWeekName = function (dictMonad) {
    return Data_Formatter_Parser_Utils.oneOfAs(Data_Functor.functorArray)(Data_Foldable.foldableArray)(dictMonad)((function () {
        var $447 = Text_Parsing_Parser_Combinators["try"](dictMonad);
        var $448 = Text_Parsing_Parser_String.string(Text_Parsing_Parser_String.stringLikeString)(dictMonad);
        return function ($449) {
            return $447($448($449));
        };
    })())([ new Data_Tuple.Tuple("Monday", Data_Date_Component.Monday.value), new Data_Tuple.Tuple("Tuesday", Data_Date_Component.Tuesday.value), new Data_Tuple.Tuple("Wednesday", Data_Date_Component.Wednesday.value), new Data_Tuple.Tuple("Thursday", Data_Date_Component.Thursday.value), new Data_Tuple.Tuple("Friday", Data_Date_Component.Friday.value), new Data_Tuple.Tuple("Saturday", Data_Date_Component.Saturday.value), new Data_Tuple.Tuple("Sunday", Data_Date_Component.Sunday.value) ]);
};
var padSingleDigit = function (i) {
    if (i < 0) {
        return "-" + padSingleDigit(-i | 0);
    };
    if (i < 10) {
        return "0" + Data_Show.show(Data_Show.showInt)(i);
    };
    if (Data_Boolean.otherwise) {
        return Data_Show.show(Data_Show.showInt)(i);
    };
    throw new Error("Failed pattern match at Data.Formatter.DateTime (line 192, column 1 - line 192, column 30): " + [ i.constructor.name ]);
};
var padQuadrupleDigit = function (i) {
    if (i < 0) {
        return "-" + padQuadrupleDigit(-i | 0);
    };
    if (i < 10) {
        return "000" + Data_Show.show(Data_Show.showInt)(i);
    };
    if (i < 100) {
        return "00" + Data_Show.show(Data_Show.showInt)(i);
    };
    if (i < 1000) {
        return "0" + Data_Show.show(Data_Show.showInt)(i);
    };
    if (Data_Boolean.otherwise) {
        return Data_Show.show(Data_Show.showInt)(i);
    };
    throw new Error("Failed pattern match at Data.Formatter.DateTime (line 205, column 1 - line 205, column 33): " + [ i.constructor.name ]);
};
var padDoubleDigit = function (i) {
    if (i < 0) {
        return "-" + padDoubleDigit(-i | 0);
    };
    if (i < 10) {
        return "00" + Data_Show.show(Data_Show.showInt)(i);
    };
    if (i < 100) {
        return "0" + Data_Show.show(Data_Show.showInt)(i);
    };
    if (Data_Boolean.otherwise) {
        return Data_Show.show(Data_Show.showInt)(i);
    };
    throw new Error("Failed pattern match at Data.Formatter.DateTime (line 198, column 1 - line 198, column 30): " + [ i.constructor.name ]);
};
var initialAccum = {
    year: Data_Maybe.Nothing.value,
    month: Data_Maybe.Nothing.value,
    day: Data_Maybe.Nothing.value,
    hour: Data_Maybe.Nothing.value,
    minute: Data_Maybe.Nothing.value,
    second: Data_Maybe.Nothing.value,
    millisecond: Data_Maybe.Nothing.value,
    meridiem: Data_Maybe.Nothing.value
};
var genericFormatter = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof YearFull) {
        return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
    };
    if (x instanceof YearTwoDigits) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
    };
    if (x instanceof YearAbsolute) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
    };
    if (x instanceof MonthFull) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
    };
    if (x instanceof MonthShort) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
    };
    if (x instanceof MonthTwoDigits) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
    };
    if (x instanceof DayOfMonthTwoDigits) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))));
    };
    if (x instanceof DayOfMonth) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))));
    };
    if (x instanceof UnixTimestamp) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))));
    };
    if (x instanceof DayOfWeek) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))));
    };
    if (x instanceof DayOfWeekName) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))));
    };
    if (x instanceof DayOfWeekNameShort) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))));
    };
    if (x instanceof Hours24) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))));
    };
    if (x instanceof Hours12) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))));
    };
    if (x instanceof Meridiem) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))))));
    };
    if (x instanceof Minutes) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))))));
    };
    if (x instanceof MinutesTwoDigits) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))))))));
    };
    if (x instanceof Seconds) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))))))));
    };
    if (x instanceof SecondsTwoDigits) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))))))))));
    };
    if (x instanceof Milliseconds) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))))))))));
    };
    if (x instanceof MillisecondsShort) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))))))))))));
    };
    if (x instanceof MillisecondsTwoDigits) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))))))))))))));
    };
    if (x instanceof Placeholder) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))))))))))))))))))))));
    };
    throw new Error("Failed pattern match at Data.Formatter.DateTime (line 77, column 1 - line 77, column 62): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return YearFull.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return YearTwoDigits.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return YearAbsolute.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
        return MonthFull.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
        return MonthShort.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
        return MonthTwoDigits.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
        return DayOfMonthTwoDigits.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
        return DayOfMonth.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
        return UnixTimestamp.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))) {
        return DayOfWeek.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))) {
        return DayOfWeekName.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))) {
        return DayOfWeekNameShort.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))) {
        return Hours24.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))) {
        return Hours12.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))) {
        return Meridiem.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))) {
        return Minutes.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))))) {
        return MinutesTwoDigits.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))))) {
        return Seconds.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))))))) {
        return SecondsTwoDigits.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))))))) {
        return Milliseconds.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))))))))) {
        return MillisecondsShort.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))))))))) {
        return MillisecondsTwoDigits.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))))))))))))))))))) {
        return new Placeholder(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    throw new Error("Failed pattern match at Data.Formatter.DateTime (line 77, column 1 - line 77, column 62): " + [ x.constructor.name ]);
});
var showFormatter = new Data_Show.Show(Data_Generic_Rep_Show.genericShow(genericFormatter)(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "YearFull";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "YearTwoDigits";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "YearAbsolute";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "MonthFull";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "MonthShort";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "MonthTwoDigits";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "DayOfMonthTwoDigits";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "DayOfMonth";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "UnixTimestamp";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "DayOfWeek";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "DayOfWeekName";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "DayOfWeekNameShort";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Hours24";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Hours12";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Meridiem";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Minutes";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "MinutesTwoDigits";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Seconds";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "SecondsTwoDigits";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Milliseconds";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "MillisecondsShort";
})))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "MillisecondsTwoDigits";
})))(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Data_Show.showString))(new Data_Symbol.IsSymbol(function () {
    return "Placeholder";
}))))))))))))))))))))))))));
var formatterCommandParser = Control_Alt.alt(Text_Parsing_Parser.altParserT(Data_Identity.monadIdentity))(Data_Formatter_Parser_Utils.oneOfAs(Data_Functor.functorArray)(Data_Foldable.foldableArray)(Data_Identity.monadIdentity)((function () {
    var $450 = Text_Parsing_Parser_Combinators["try"](Data_Identity.monadIdentity);
    var $451 = Text_Parsing_Parser_String.string(Text_Parsing_Parser_String.stringLikeString)(Data_Identity.monadIdentity);
    return function ($452) {
        return $450($451($452));
    };
})())([ new Data_Tuple.Tuple("YYYY", YearFull.value), new Data_Tuple.Tuple("YY", YearTwoDigits.value), new Data_Tuple.Tuple("Y", YearAbsolute.value), new Data_Tuple.Tuple("MMMM", MonthFull.value), new Data_Tuple.Tuple("MMM", MonthShort.value), new Data_Tuple.Tuple("MM", MonthTwoDigits.value), new Data_Tuple.Tuple("DD", DayOfMonthTwoDigits.value), new Data_Tuple.Tuple("D", DayOfMonth.value), new Data_Tuple.Tuple("E", DayOfWeek.value), new Data_Tuple.Tuple("X", UnixTimestamp.value), new Data_Tuple.Tuple("dddd", DayOfWeekName.value), new Data_Tuple.Tuple("ddd", DayOfWeekNameShort.value), new Data_Tuple.Tuple("HH", Hours24.value), new Data_Tuple.Tuple("hh", Hours12.value), new Data_Tuple.Tuple("a", Meridiem.value), new Data_Tuple.Tuple("mm", MinutesTwoDigits.value), new Data_Tuple.Tuple("m", Minutes.value), new Data_Tuple.Tuple("ss", SecondsTwoDigits.value), new Data_Tuple.Tuple("s", Seconds.value), new Data_Tuple.Tuple("SSS", Milliseconds.value), new Data_Tuple.Tuple("SS", MillisecondsTwoDigits.value), new Data_Tuple.Tuple("S", MillisecondsShort.value) ]))(Data_Functor.map(Text_Parsing_Parser.functorParserT(Data_Identity.functorIdentity))(Placeholder.create)(placeholderContent));
var formatYearTwoDigits = function (i) {
    var dateString = Data_Show.show(Data_Show.showInt)(Data_Ord.abs(Data_Ord.ordInt)(Data_Ring.ringInt)(i));
    var dateLength = Data_String_CodePoints.length(dateString);
    if (dateLength === 1) {
        return "0" + dateString;
    };
    if (dateLength === 2) {
        return dateString;
    };
    return Data_String_CodePoints.drop(dateLength - 2 | 0)(dateString);
};
var formatParser = Data_List.some(Text_Parsing_Parser.alternativeParserT(Data_Identity.monadIdentity))(Text_Parsing_Parser.lazyParserT)(formatterCommandParser);
var parseFormatString = Data_Formatter_Parser_Utils.runP(Text_Parsing_Parser_String.stringLikeString)(formatParser);
var fix12 = function (h) {
    var $394 = h === 0;
    if ($394) {
        return 12;
    };
    return h;
};
var formatCommand = function (v) {
    return function (v1) {
        if (v1 instanceof YearFull) {
            return padQuadrupleDigit(Data_Enum.fromEnum(Data_Date_Component.boundedEnumYear)(Data_Date.year(v.value0)));
        };
        if (v1 instanceof YearTwoDigits) {
            return formatYearTwoDigits(Data_Enum.fromEnum(Data_Date_Component.boundedEnumYear)(Data_Date.year(v.value0)));
        };
        if (v1 instanceof YearAbsolute) {
            return Data_Show.show(Data_Show.showInt)(Data_Enum.fromEnum(Data_Date_Component.boundedEnumYear)(Data_Date.year(v.value0)));
        };
        if (v1 instanceof MonthFull) {
            return Data_Show.show(Data_Date_Component.showMonth)(Data_Date.month(v.value0));
        };
        if (v1 instanceof MonthShort) {
            return printShortMonth(Data_Date.month(v.value0));
        };
        if (v1 instanceof MonthTwoDigits) {
            return padSingleDigit(Data_Enum.fromEnum(Data_Date_Component.boundedEnumMonth)(Data_Date.month(v.value0)));
        };
        if (v1 instanceof DayOfMonthTwoDigits) {
            return padSingleDigit(Data_Enum.fromEnum(Data_Date_Component.boundedEnumDay)(Data_Date.day(v.value0)));
        };
        if (v1 instanceof DayOfMonth) {
            return Data_Show.show(Data_Show.showInt)(Data_Enum.fromEnum(Data_Date_Component.boundedEnumDay)(Data_Date.day(v.value0)));
        };
        if (v1 instanceof UnixTimestamp) {
            return Data_Show.show(Data_Show.showInt)(Data_Int.floor((function (v2) {
                return v2 / 1000.0;
            })(Data_Newtype.unwrap(Data_Time_Duration.newtypeMilliseconds)(Data_DateTime_Instant.unInstant(Data_DateTime_Instant.fromDateTime(v))))));
        };
        if (v1 instanceof DayOfWeek) {
            return Data_Show.show(Data_Show.showInt)(Data_Enum.fromEnum(Data_Date_Component.boundedEnumWeekday)(Data_Date.weekday(v.value0)));
        };
        if (v1 instanceof DayOfWeekName) {
            return Data_Show.show(Data_Date_Component.showWeekday)(Data_Date.weekday(v.value0));
        };
        if (v1 instanceof DayOfWeekNameShort) {
            return Data_String_CodePoints.take(3)(Data_Show.show(Data_Date_Component.showWeekday)(Data_Date.weekday(v.value0)));
        };
        if (v1 instanceof Hours24) {
            return padSingleDigit(Data_Enum.fromEnum(Data_Time_Component.boundedEnumHour)(Data_Time.hour(v.value1)));
        };
        if (v1 instanceof Hours12) {
            return padSingleDigit(fix12(Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(Data_Enum.fromEnum(Data_Time_Component.boundedEnumHour)(Data_Time.hour(v.value1)))(12)));
        };
        if (v1 instanceof Meridiem) {
            var $397 = Data_Enum.fromEnum(Data_Time_Component.boundedEnumHour)(Data_Time.hour(v.value1)) >= 12;
            if ($397) {
                return "PM";
            };
            return "AM";
        };
        if (v1 instanceof Minutes) {
            return Data_Show.show(Data_Show.showInt)(Data_Enum.fromEnum(Data_Time_Component.boundedEnumMinute)(Data_Time.minute(v.value1)));
        };
        if (v1 instanceof MinutesTwoDigits) {
            return padSingleDigit(Data_Enum.fromEnum(Data_Time_Component.boundedEnumMinute)(Data_Time.minute(v.value1)));
        };
        if (v1 instanceof Seconds) {
            return Data_Show.show(Data_Show.showInt)(Data_Enum.fromEnum(Data_Time_Component.boundedEnumSecond)(Data_Time.second(v.value1)));
        };
        if (v1 instanceof SecondsTwoDigits) {
            return padSingleDigit(Data_Enum.fromEnum(Data_Time_Component.boundedEnumSecond)(Data_Time.second(v.value1)));
        };
        if (v1 instanceof Milliseconds) {
            return padDoubleDigit(Data_Enum.fromEnum(Data_Time_Component.boundedEnumMillisecond)(Data_Time.millisecond(v.value1)));
        };
        if (v1 instanceof MillisecondsShort) {
            return Data_Show.show(Data_Show.showInt)((function (v2) {
                return Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(v2)(100);
            })(Data_Enum.fromEnum(Data_Time_Component.boundedEnumMillisecond)(Data_Time.millisecond(v.value1))));
        };
        if (v1 instanceof MillisecondsTwoDigits) {
            return padSingleDigit((function (v2) {
                return Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(v2)(10);
            })(Data_Enum.fromEnum(Data_Time_Component.boundedEnumMillisecond)(Data_Time.millisecond(v.value1))));
        };
        if (v1 instanceof Placeholder) {
            return v1.value0;
        };
        throw new Error("Failed pattern match at Data.Formatter.DateTime (line 167, column 38 - line 190, column 20): " + [ v1.constructor.name ]);
    };
};
var format = function (f) {
    return function (d) {
        return Data_Foldable.foldMap(Data_List_Types.foldableList)(Data_Monoid.monoidString)(formatCommand(d))(f);
    };
};
var formatDateTime = function (pattern) {
    return function (datetime) {
        return Data_Functor.mapFlipped(Data_Either.functorEither)(parseFormatString(pattern))(function (v) {
            return format(v)(datetime);
        });
    };
};
var exactLength = Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Either.bindEither))(Control_Monad_Reader_Class.ask(Control_Monad_Reader_Trans.monadAskReaderT(Data_Either.monadEither)))(function (v) {
    return Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(Data_Either.monadEither)((function () {
        var $402 = v.maxLength !== v.length;
        if ($402) {
            return Data_Either.Left.create("Expected " + (Data_Show.show(Data_Show.showInt)(v.maxLength) + (" digits but got " + Data_Show.show(Data_Show.showInt)(v.length))));
        };
        return new Data_Either.Right(Data_Unit.unit);
    })());
});
var unformatCommandParser = (function () {
    var modifyWithParser = function (f) {
        return function (p) {
            return Control_Bind.bind(Text_Parsing_Parser.bindParserT(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity)))(p)(function (v) {
                return Control_Monad_Trans_Class.lift(Text_Parsing_Parser.monadTransParserT)(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.modify_(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(Data_Function.flip(f)(new Data_Maybe.Just(v))));
            });
        };
    };
    return function (v) {
        if (v instanceof YearFull) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        year: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second
                    };
                };
            })(parseSignedInt(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(4)(exactLength)("Incorrect full year"));
        };
        if (v instanceof YearTwoDigits) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        year: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second
                    };
                };
            })(parseSignedInt(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(2)(exactLength)("Incorrect 2-digit year"));
        };
        if (v instanceof YearAbsolute) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        year: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second
                    };
                };
            })(Control_Apply.lift2(Text_Parsing_Parser.applyParserT(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity)))(Data_Semiring.mul(Data_Semiring.semiringInt))(Text_Parsing_Parser_Combinators.option(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(1)(Text_Parsing_Parser_Combinators["try"](Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(Data_Functor.mapFlipped(Text_Parsing_Parser.functorParserT(Control_Monad_State_Trans.functorStateT(Data_Identity.functorIdentity)))(Text_Parsing_Parser_String.string(Text_Parsing_Parser_String.stringLikeString)(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))("-"))(Data_Function["const"](-1 | 0)))))(Data_Functor.mapFlipped(Text_Parsing_Parser.functorParserT(Control_Monad_State_Trans.functorStateT(Data_Identity.functorIdentity)))(Data_List.some(Text_Parsing_Parser.alternativeParserT(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity)))(Text_Parsing_Parser.lazyParserT)(Data_Formatter_Parser_Number.parseDigit(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(Text_Parsing_Parser_String.stringLikeString)))(Data_Formatter_Internal.foldDigits(Data_List_Types.foldableList))));
        };
        if (v instanceof MonthFull) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        month: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(Data_Functor.map(Text_Parsing_Parser.functorParserT(Control_Monad_State_Trans.functorStateT(Data_Identity.functorIdentity)))(Data_Enum.fromEnum(Data_Date_Component.boundedEnumMonth))(parseMonth(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))));
        };
        if (v instanceof MonthShort) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        month: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(Data_Functor.map(Text_Parsing_Parser.functorParserT(Control_Monad_State_Trans.functorStateT(Data_Identity.functorIdentity)))(Data_Enum.fromEnum(Data_Date_Component.boundedEnumMonth))(parseShortMonth(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))));
        };
        if (v instanceof MonthTwoDigits) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        month: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })($$parseInt(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(2)(Data_Semigroup.append(Control_Monad_Reader_Trans.semigroupReaderT(Data_Either.applyEither)(Data_Semigroup.semigroupUnit))(validateRange(1)(12))(exactLength))("Incorrect 2-digit month"));
        };
        if (v instanceof DayOfMonthTwoDigits) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        day: v2,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })($$parseInt(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(2)(Data_Semigroup.append(Control_Monad_Reader_Trans.semigroupReaderT(Data_Either.applyEither)(Data_Semigroup.semigroupUnit))(validateRange(1)(31))(exactLength))("Incorrect day of month"));
        };
        if (v instanceof DayOfMonth) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        day: v2,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })($$parseInt(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(2)(validateRange(1)(31))("Incorrect day of month"));
        };
        if (v instanceof UnixTimestamp) {
            return Control_Bind.bind(Text_Parsing_Parser.bindParserT(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity)))(Data_Functor.map(Text_Parsing_Parser.functorParserT(Control_Monad_State_Trans.functorStateT(Data_Identity.functorIdentity)))(Data_Formatter_Internal.foldDigits(Data_List_Types.foldableList))(Data_List.some(Text_Parsing_Parser.alternativeParserT(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity)))(Text_Parsing_Parser.lazyParserT)(Data_Formatter_Parser_Number.parseDigit(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(Text_Parsing_Parser_String.stringLikeString))))(function (s) {
                var v1 = Data_Functor.map(Data_Maybe.functorMaybe)(Data_DateTime_Instant.toDateTime)(Data_DateTime_Instant.instant(Data_Time_Duration.Milliseconds(1000.0 * Data_Int.toNumber(s))));
                if (v1 instanceof Data_Maybe.Nothing) {
                    return Text_Parsing_Parser.fail(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))("Incorrect timestamp");
                };
                if (v1 instanceof Data_Maybe.Just) {
                    return Control_Monad_Trans_Class.lift(Text_Parsing_Parser.monadTransParserT)(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.put(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))({
                        year: Data_Maybe.Just.create(Data_Enum.fromEnum(Data_Date_Component.boundedEnumYear)(Data_Date.year(v1.value0.value0))),
                        month: Data_Maybe.Just.create(Data_Enum.fromEnum(Data_Date_Component.boundedEnumMonth)(Data_Date.month(v1.value0.value0))),
                        day: Data_Maybe.Just.create(Data_Enum.fromEnum(Data_Date_Component.boundedEnumDay)(Data_Date.day(v1.value0.value0))),
                        hour: Data_Maybe.Just.create(Data_Enum.fromEnum(Data_Time_Component.boundedEnumHour)(Data_Time.hour(v1.value0.value1))),
                        minute: Data_Maybe.Just.create(Data_Enum.fromEnum(Data_Time_Component.boundedEnumMinute)(Data_Time.minute(v1.value0.value1))),
                        second: Data_Maybe.Just.create(Data_Enum.fromEnum(Data_Time_Component.boundedEnumSecond)(Data_Time.second(v1.value0.value1))),
                        millisecond: Data_Maybe.Just.create(Data_Enum.fromEnum(Data_Time_Component.boundedEnumMillisecond)(Data_Time.millisecond(v1.value0.value1))),
                        meridiem: Data_Maybe.Nothing.value
                    }));
                };
                throw new Error("Failed pattern match at Data.Formatter.DateTime (line 362, column 5 - line 373, column 10): " + [ v1.constructor.name ]);
            });
        };
        if (v instanceof DayOfWeek) {
            return Data_Functor["void"](Text_Parsing_Parser.functorParserT(Control_Monad_State_Trans.functorStateT(Data_Identity.functorIdentity)))($$parseInt(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(1)(validateRange(1)(7))("Incorrect day of week"));
        };
        if (v instanceof DayOfWeekName) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        day: v2,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(Data_Functor.map(Text_Parsing_Parser.functorParserT(Control_Monad_State_Trans.functorStateT(Data_Identity.functorIdentity)))(Data_Enum.fromEnum(Data_Date_Component.boundedEnumWeekday))(parseDayOfWeekName(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))));
        };
        if (v instanceof DayOfWeekNameShort) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        day: v2,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(Data_Functor.map(Text_Parsing_Parser.functorParserT(Control_Monad_State_Trans.functorStateT(Data_Identity.functorIdentity)))(Data_Enum.fromEnum(Data_Date_Component.boundedEnumWeekday))(parseDayOfWeekNameShort(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))));
        };
        if (v instanceof Hours24) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        hour: v2,
                        day: v1.day,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })($$parseInt(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(2)(Data_Semigroup.append(Control_Monad_Reader_Trans.semigroupReaderT(Data_Either.applyEither)(Data_Semigroup.semigroupUnit))(validateRange(0)(24))(exactLength))("Incorrect 24 hour"));
        };
        if (v instanceof Hours12) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        hour: v2,
                        day: v1.day,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })($$parseInt(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(2)(Data_Semigroup.append(Control_Monad_Reader_Trans.semigroupReaderT(Data_Either.applyEither)(Data_Semigroup.semigroupUnit))(validateRange(0)(12))(exactLength))("Incorrect 12 hour"));
        };
        if (v instanceof Meridiem) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        meridiem: v2,
                        day: v1.day,
                        hour: v1.hour,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(parseMeridiem(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity)));
        };
        if (v instanceof MinutesTwoDigits) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        minute: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })($$parseInt(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(2)(Data_Semigroup.append(Control_Monad_Reader_Trans.semigroupReaderT(Data_Either.applyEither)(Data_Semigroup.semigroupUnit))(validateRange(0)(59))(exactLength))("Incorrect 2-digit minute"));
        };
        if (v instanceof Minutes) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        minute: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })($$parseInt(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(2)(validateRange(0)(59))("Incorrect minute"));
        };
        if (v instanceof SecondsTwoDigits) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        second: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        year: v1.year
                    };
                };
            })($$parseInt(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(2)(Data_Semigroup.append(Control_Monad_Reader_Trans.semigroupReaderT(Data_Either.applyEither)(Data_Semigroup.semigroupUnit))(validateRange(0)(59))(exactLength))("Incorrect 2-digit second"));
        };
        if (v instanceof Seconds) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        second: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        millisecond: v1.millisecond,
                        minute: v1.minute,
                        month: v1.month,
                        year: v1.year
                    };
                };
            })($$parseInt(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(2)(validateRange(0)(59))("Incorrect second"));
        };
        if (v instanceof Milliseconds) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        millisecond: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })($$parseInt(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(3)(exactLength)("Incorrect millisecond"));
        };
        if (v instanceof Placeholder) {
            return Data_Functor["void"](Text_Parsing_Parser.functorParserT(Control_Monad_State_Trans.functorStateT(Data_Identity.functorIdentity)))(Text_Parsing_Parser_String.string(Text_Parsing_Parser_String.stringLikeString)(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(v.value0));
        };
        if (v instanceof MillisecondsShort) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        millisecond: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(Data_Functor.mapFlipped(Text_Parsing_Parser.functorParserT(Control_Monad_State_Trans.functorStateT(Data_Identity.functorIdentity)))($$parseInt(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(1)(exactLength)("Incorrect 1-digit millisecond"))(function (v1) {
                return v1 * 100 | 0;
            }));
        };
        if (v instanceof MillisecondsTwoDigits) {
            return modifyWithParser(function (v1) {
                return function (v2) {
                    return {
                        millisecond: v2,
                        day: v1.day,
                        hour: v1.hour,
                        meridiem: v1.meridiem,
                        minute: v1.minute,
                        month: v1.month,
                        second: v1.second,
                        year: v1.year
                    };
                };
            })(Data_Functor.mapFlipped(Text_Parsing_Parser.functorParserT(Control_Monad_State_Trans.functorStateT(Data_Identity.functorIdentity)))($$parseInt(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(2)(exactLength)("Incorrect 2-digit millisecond"))(function (v1) {
                return v1 * 10 | 0;
            }));
        };
        throw new Error("Failed pattern match at Data.Formatter.DateTime (line 341, column 25 - line 399, column 74): " + [ v.constructor.name ]);
    };
})();
var eqMeridiem = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof AM && y instanceof AM) {
            return true;
        };
        if (x instanceof PM && y instanceof PM) {
            return true;
        };
        return false;
    };
});
var eqFormatterCommand = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof YearFull && y instanceof YearFull) {
            return true;
        };
        if (x instanceof YearTwoDigits && y instanceof YearTwoDigits) {
            return true;
        };
        if (x instanceof YearAbsolute && y instanceof YearAbsolute) {
            return true;
        };
        if (x instanceof MonthFull && y instanceof MonthFull) {
            return true;
        };
        if (x instanceof MonthShort && y instanceof MonthShort) {
            return true;
        };
        if (x instanceof MonthTwoDigits && y instanceof MonthTwoDigits) {
            return true;
        };
        if (x instanceof DayOfMonthTwoDigits && y instanceof DayOfMonthTwoDigits) {
            return true;
        };
        if (x instanceof DayOfMonth && y instanceof DayOfMonth) {
            return true;
        };
        if (x instanceof UnixTimestamp && y instanceof UnixTimestamp) {
            return true;
        };
        if (x instanceof DayOfWeek && y instanceof DayOfWeek) {
            return true;
        };
        if (x instanceof DayOfWeekName && y instanceof DayOfWeekName) {
            return true;
        };
        if (x instanceof DayOfWeekNameShort && y instanceof DayOfWeekNameShort) {
            return true;
        };
        if (x instanceof Hours24 && y instanceof Hours24) {
            return true;
        };
        if (x instanceof Hours12 && y instanceof Hours12) {
            return true;
        };
        if (x instanceof Meridiem && y instanceof Meridiem) {
            return true;
        };
        if (x instanceof Minutes && y instanceof Minutes) {
            return true;
        };
        if (x instanceof MinutesTwoDigits && y instanceof MinutesTwoDigits) {
            return true;
        };
        if (x instanceof Seconds && y instanceof Seconds) {
            return true;
        };
        if (x instanceof SecondsTwoDigits && y instanceof SecondsTwoDigits) {
            return true;
        };
        if (x instanceof Milliseconds && y instanceof Milliseconds) {
            return true;
        };
        if (x instanceof MillisecondsShort && y instanceof MillisecondsShort) {
            return true;
        };
        if (x instanceof MillisecondsTwoDigits && y instanceof MillisecondsTwoDigits) {
            return true;
        };
        if (x instanceof Placeholder && y instanceof Placeholder) {
            return x.value0 === y.value0;
        };
        return false;
    };
});
var ordFormatterCommand = new Data_Ord.Ord(function () {
    return eqFormatterCommand;
}, function (x) {
    return function (y) {
        if (x instanceof YearFull && y instanceof YearFull) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof YearFull) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof YearFull) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof YearTwoDigits && y instanceof YearTwoDigits) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof YearTwoDigits) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof YearTwoDigits) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof YearAbsolute && y instanceof YearAbsolute) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof YearAbsolute) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof YearAbsolute) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof MonthFull && y instanceof MonthFull) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof MonthFull) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof MonthFull) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof MonthShort && y instanceof MonthShort) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof MonthShort) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof MonthShort) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof MonthTwoDigits && y instanceof MonthTwoDigits) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof MonthTwoDigits) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof MonthTwoDigits) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof DayOfMonthTwoDigits && y instanceof DayOfMonthTwoDigits) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof DayOfMonthTwoDigits) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof DayOfMonthTwoDigits) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof DayOfMonth && y instanceof DayOfMonth) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof DayOfMonth) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof DayOfMonth) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof UnixTimestamp && y instanceof UnixTimestamp) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof UnixTimestamp) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof UnixTimestamp) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof DayOfWeek && y instanceof DayOfWeek) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof DayOfWeek) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof DayOfWeek) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof DayOfWeekName && y instanceof DayOfWeekName) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof DayOfWeekName) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof DayOfWeekName) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof DayOfWeekNameShort && y instanceof DayOfWeekNameShort) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof DayOfWeekNameShort) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof DayOfWeekNameShort) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Hours24 && y instanceof Hours24) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Hours24) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Hours24) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Hours12 && y instanceof Hours12) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Hours12) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Hours12) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Meridiem && y instanceof Meridiem) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Meridiem) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Meridiem) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Minutes && y instanceof Minutes) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Minutes) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Minutes) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof MinutesTwoDigits && y instanceof MinutesTwoDigits) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof MinutesTwoDigits) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof MinutesTwoDigits) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Seconds && y instanceof Seconds) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Seconds) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Seconds) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof SecondsTwoDigits && y instanceof SecondsTwoDigits) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof SecondsTwoDigits) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof SecondsTwoDigits) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Milliseconds && y instanceof Milliseconds) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Milliseconds) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Milliseconds) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof MillisecondsShort && y instanceof MillisecondsShort) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof MillisecondsShort) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof MillisecondsShort) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof MillisecondsTwoDigits && y instanceof MillisecondsTwoDigits) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof MillisecondsTwoDigits) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof MillisecondsTwoDigits) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Placeholder && y instanceof Placeholder) {
            return Data_Ord.compare(Data_Ord.ordString)(x.value0)(y.value0);
        };
        throw new Error("Failed pattern match at Data.Formatter.DateTime (line 76, column 1 - line 76, column 59): " + [ x.constructor.name, y.constructor.name ]);
    };
});
var adjustMeridiem = function (v) {
    return function (v1) {
        if (v instanceof Data_Maybe.Just && (v.value0 instanceof AM && v1 === 12)) {
            return 0;
        };
        if (v instanceof Data_Maybe.Just && (v.value0 instanceof PM && v1 === 12)) {
            return 12;
        };
        if (v instanceof Data_Maybe.Just && v.value0 instanceof PM) {
            return v1 + 12 | 0;
        };
        if (v instanceof Data_Maybe.Just && v.value0 instanceof AM) {
            return v1;
        };
        if (v instanceof Data_Maybe.Nothing && v1 === 24) {
            return 0;
        };
        if (v instanceof Data_Maybe.Nothing) {
            return v1;
        };
        throw new Error("Failed pattern match at Data.Formatter.DateTime (line 279, column 1 - line 279, column 44): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var adjustDay = function (v) {
    return function (n) {
        if (v instanceof Data_Maybe.Just && v.value0 === 24) {
            return n + 1 | 0;
        };
        return n;
    };
};
var unformatAccumToDateTime = function (a) {
    return Control_Apply.applySecond(Data_Either.applyEither)(validAccum(a))(Control_Apply.apply(Data_Either.applyEither)(Data_Functor.map(Data_Either.functorEither)(Data_DateTime.DateTime.create)(Control_Apply.apply(Data_Either.applyEither)(Control_Apply.apply(Data_Either.applyEither)(Data_Functor.map(Data_Either.functorEither)(Data_Date.canonicalDate)(Data_Maybe.maybe(new Data_Either.Left("Incorrect year"))(Control_Applicative.pure(Data_Either.applicativeEither))(Data_Enum.toEnum(Data_Date_Component.boundedEnumYear)(Data_Maybe.fromMaybe(0)(a.year)))))(Data_Maybe.maybe(new Data_Either.Left("Incorrect month"))(Control_Applicative.pure(Data_Either.applicativeEither))(Data_Enum.toEnum(Data_Date_Component.boundedEnumMonth)(Data_Maybe.fromMaybe(1)(a.month)))))(Data_Maybe.maybe(new Data_Either.Left("Incorrect day"))(Control_Applicative.pure(Data_Either.applicativeEither))(Data_Enum.toEnum(Data_Date_Component.boundedEnumDay)(adjustDay(a.hour)(Data_Maybe.fromMaybe(1)(a.day)))))))(Control_Apply.apply(Data_Either.applyEither)(Control_Apply.apply(Data_Either.applyEither)(Control_Apply.apply(Data_Either.applyEither)(Data_Functor.map(Data_Either.functorEither)(Data_Time.Time.create)(Data_Maybe.maybe(new Data_Either.Left("Incorrect hour"))(Control_Applicative.pure(Data_Either.applicativeEither))(Data_Enum.toEnum(Data_Time_Component.boundedEnumHour)(Data_Maybe.fromMaybe(0)(Data_Functor.map(Data_Maybe.functorMaybe)(adjustMeridiem(a.meridiem))(a.hour))))))(Data_Maybe.maybe(new Data_Either.Left("Incorrect minute"))(Control_Applicative.pure(Data_Either.applicativeEither))(Data_Enum.toEnum(Data_Time_Component.boundedEnumMinute)(Data_Maybe.fromMaybe(0)(a.minute)))))(Data_Maybe.maybe(new Data_Either.Left("Incorrect second"))(Control_Applicative.pure(Data_Either.applicativeEither))(Data_Enum.toEnum(Data_Time_Component.boundedEnumSecond)(Data_Maybe.fromMaybe(0)(a.second)))))(Data_Maybe.maybe(new Data_Either.Left("Incorrect millisecond"))(Control_Applicative.pure(Data_Either.applicativeEither))(Data_Enum.toEnum(Data_Time_Component.boundedEnumMillisecond)(Data_Maybe.fromMaybe(0)(a.millisecond))))));
};
var unformatParser = function (dictMonad) {
    return function (f) {
        var unState = function (dictMonad1) {
            return function (s) {
                var v = Control_Monad_State.runState(s)(initialAccum);
                return Control_Applicative.pure(dictMonad1.Applicative0())(new Data_Tuple.Tuple(Data_Functor.voidLeft(Data_Either.functorEither)(v.value0.value0)(v.value1), v.value0.value1));
            };
        };
        return Control_Bind.bind(Text_Parsing_Parser.bindParserT(dictMonad))(Text_Parsing_Parser.mapParserT(unState(dictMonad))(Data_Foldable.foldMap(Data_List_Types.foldableList)(Text_Parsing_Parser.monoidParserT(Control_Monad_State_Trans.monadStateT(Data_Identity.monadIdentity))(Data_Monoid.monoidUnit))(unformatCommandParser)(f)))(function (acc) {
            return Data_Either.either(Text_Parsing_Parser.fail(dictMonad))(Control_Applicative.pure(Text_Parsing_Parser.applicativeParserT(dictMonad)))(unformatAccumToDateTime(acc));
        });
    };
};
var unformat = (function () {
    var $453 = Data_Formatter_Parser_Utils.runP(Text_Parsing_Parser_String.stringLikeString);
    var $454 = unformatParser(Data_Identity.monadIdentity);
    return function ($455) {
        return $453($454($455));
    };
})();
var unformatDateTime = function (pattern) {
    return function (str) {
        return Control_Bind.bind(Data_Either.bindEither)(parseFormatString(pattern))(function (v) {
            return unformat(v)(str);
        });
    };
};
module.exports = {
    YearFull: YearFull,
    YearTwoDigits: YearTwoDigits,
    YearAbsolute: YearAbsolute,
    MonthFull: MonthFull,
    MonthShort: MonthShort,
    MonthTwoDigits: MonthTwoDigits,
    DayOfMonthTwoDigits: DayOfMonthTwoDigits,
    DayOfMonth: DayOfMonth,
    UnixTimestamp: UnixTimestamp,
    DayOfWeek: DayOfWeek,
    DayOfWeekName: DayOfWeekName,
    DayOfWeekNameShort: DayOfWeekNameShort,
    Hours24: Hours24,
    Hours12: Hours12,
    Meridiem: Meridiem,
    Minutes: Minutes,
    MinutesTwoDigits: MinutesTwoDigits,
    Seconds: Seconds,
    SecondsTwoDigits: SecondsTwoDigits,
    Milliseconds: Milliseconds,
    MillisecondsShort: MillisecondsShort,
    MillisecondsTwoDigits: MillisecondsTwoDigits,
    Placeholder: Placeholder,
    printFormatter: printFormatter,
    printFormatterCommand: printFormatterCommand,
    parseFormatString: parseFormatString,
    format: format,
    formatDateTime: formatDateTime,
    unformat: unformat,
    unformatDateTime: unformatDateTime,
    unformatParser: unformatParser,
    eqFormatterCommand: eqFormatterCommand,
    ordFormatterCommand: ordFormatterCommand,
    genericFormatter: genericFormatter,
    showFormatter: showFormatter,
    eqMeridiem: eqMeridiem
};
